<template>
  <v-container>
    <v-card max-width="400" class="elevation-12 mx-auto pb-5 pt-0">
      <v-toolbar dark color="user_primary">
        <v-toolbar-title class="text-sm-h5 mx-auto"
          >Web Forms Examples</v-toolbar-title
        >
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'stylist-certification',
                params: {
                  stylistId: stylistAccountId,
                  applicationId: applicationId,
                  certification: StylistsCertifications.LB_HALF
                }
              }"
              >LB HALF</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'stylist-certification',
                params: {
                  stylistId: stylistAccountId,
                  applicationId: applicationId,
                  certification: StylistsCertifications.LB_FULL
                }
              }"
              >LB FULL</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'stylist-certification',
                params: {
                  stylistId: stylistAccountId,
                  applicationId: applicationId,
                  certification: StylistsCertifications.ML_REGULAR
                }
              }"
              >ML REGULAR</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'stylist-certification',
                params: {
                  stylistId: stylistAccountId,
                  applicationId: applicationId,
                  certification: StylistsCertifications.ML_CUTTING
                }
              }"
              >ML CUTTING</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'stylist-certification',
                params: {
                  stylistId: stylistAccountId,
                  applicationId: applicationId,
                  certification: StylistsCertifications.FS_ONLINE
                }
              }"
              >FS ONLINE</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'stylist-certification',
                params: {
                  stylistId: stylistAccountId,
                  applicationId: applicationId,
                  certification: StylistsCertifications.FS_IN_PERSON
                }
              }"
              >FS IN-PERSON</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'Salons'
              }"
              >Admin</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'SalonHome'
              }"
              >Salon Home Page</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'SalonMessages',
                params: { salonId }
              }"
              >Salon Messages Dashboard</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{ name: 'userType' }"
              >Web Form 1: Find a salon</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'GreatNews',
                params: {
                  consumerId,
                  salonId
                }
              }"
              >Web Form 2: Great News</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'NoSalonFound',
                params: { consumerId: emptyConsumerId }
              }"
              >Web Form 2.1: No Salon Found</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'NewConsumerContact',
                query: { source: ContactMessageSources.example_page }
              }"
              >Web Form 2.2: Contact Page</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'Welcome'
              }"
              >Web Form 2.3: Welcome</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'NewInquiry',
                params: {
                  consumerId: newInquiryConsumerId,
                  salonId: newInquirySalonId
                }
              }"
              >Web Form 3: New Inquiry</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              :to="{
                name: 'DiscountPage',
                params: { consumerId, salonId }
              }"
              dark
              right
              >Web Form 4: Discount Page</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{ name: 'FindSalon' }"
              >Web Form 5: Salon Sign Up</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{ name: 'PendingSalons' }"
              >Web Form 5.1: Pending Salons</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'Communication',
                params: {
                  consumerId: newInquiryConsumerId,
                  salonId: newInquirySalonId
                }
              }"
              >Web Form 6: Communication</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'AdminCommunication',
                params: {
                  consumerId: newInquiryConsumerId,
                  salonId: newInquirySalonId
                }
              }"
              >Web Form 6.1: Communication</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'Agreement'
              }"
              >Web Form 7: Agreement</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'Certification'
              }"
              >Certification</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'Unsubscribe',
                params: { consumerId: this.consumerId }
              }"
              >Web Form 8: Unsubscribe</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="primary"
              dark
              right
              :to="{
                name: 'SendEmails'
              }"
              >Web Form 9: Send E-Mails</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'CCPA'
              }"
              >CCPA Compliance</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'WF11_Stylists',
                query: { system: SystemOptions.LASERBEAMER }
              }"
              >WF11: Stylists (NANO)</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'WF11_Stylists',
                query: { system: SystemOptions.FREESTYLER }
              }"
              >WF11: Stylists (FREESTYLER)</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'WF11_Stylists',
                query: { system: SystemOptions.MICROLINES }
              }"
              >WF11: Stylists (MICROLINES)</v-btn
            >
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'WF12_Contact'
              }"
              >WF12: Contact</v-btn
            >
          </v-col>
        </v-row> -->
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'GlobalContactPage',
                params: { source: 'fb-ig-ad-ml' }
              }"
              >CONTACT PAGE: MICROLINES</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'GlobalContactPage',
                params: { source: 'fb-ig-ad-lb' }
              }"
              >CONTACT PAGE: NANO</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'GlobalContactPage',
                params: { source: 'fb-ig-ad-fs' }
              }"
              >CONTACT PAGE: FREESTYLER</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              class="text-caption text-sm-button"
              width="100%"
              color="user_primary"
              dark
              right
              :to="{
                name: 'GlobalContactPage',
                params: { source: 'fb-ig-ad-ta' }
              }"
              >CONTACT PAGE: TAPES</v-btn
            >
          </v-col>
        </v-row>

        <!-- INVESTIGATION_UI_FINAL_STATUS_DIAGNOSTICS: set showFinalStatusDiagnosticsUi=true in data() to re-enable -->
        <template v-if="showFinalStatusDiagnosticsUi">
          <v-divider class="my-4"></v-divider>
          <v-row>
            <v-col class="py-0">
              <v-card class="pa-3" outlined>
                <div class="text-subtitle-1 mb-2">
                  Final status diagnostics (temporary)
                </div>
                <v-text-field
                  v-model="diagnosticApplicationId"
                  label="Application ID"
                  outlined
                  dense
                  hide-details
                  placeholder="Paste ObjectId"
                  class="mb-3"
                />
                <v-row align="center">
                  <v-col cols="12" md="6">
                    <v-btn
                      color="user_primary"
                      dark
                      block
                      :loading="diagnosticLoading"
                      :disabled="!isValidDiagnosticId"
                      @click="runFinalStatusDiagnostics"
                    >
                      Run diagnostics
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="6" class="d-flex justify-end">
                    <v-btn
                      v-if="diagnosticResult"
                      text
                      color="primary"
                      class="px-0"
                      @click="copyDiagnosticResult"
                    >
                      Copy JSON
                    </v-btn>
                  </v-col>
                </v-row>

                <v-alert
                  v-if="diagnosticError"
                  type="error"
                  dense
                  text
                  class="my-2"
                >
                  {{ diagnosticError }}
                </v-alert>

                <v-alert
                  v-if="diagnosticResult && diagnosticResult.finalStatusUrl"
                  type="info"
                  dense
                  text
                  class="my-2"
                >
                  <div>
                    <div>
                      Final status URL:
                      <a :href="diagnosticResult.finalStatusUrl" target="_blank">
                        open
                      </a>
                    </div>
                    <div>
                      Admin final status URL:
                      <a
                        :href="diagnosticResult.adminFinalStatusUrl"
                        target="_blank"
                      >
                        open
                      </a>
                    </div>
                  </div>
                </v-alert>

                <v-alert
                  v-if="diagnosticResult"
                  :type="diagnosticMissingClicks > 0 ? 'warning' : 'success'"
                  dense
                  text
                  class="my-2"
                >
                  <div class="font-weight-medium">Quick report (English)</div>
                  <div>{{ diagnosticHeadline }}</div>
                  <div
                    v-for="line in diagnosticEnglishReport"
                    :key="line"
                    class="diagnostic-report-line"
                  >
                    {{ line }}
                  </div>
                </v-alert>

                <pre
                  v-if="diagnosticResult"
                  class="diagnostic-output"
                  >{{ formattedDiagnosticResult }}</pre
                >
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import api from '@/services/api.service'
  import {
    ContactMessageSources,
    StylistsCertifications,
    SystemOptions
  } from '@/config/enums'

  export default {
    data() {
      return {
        SystemOptions,
        ContactMessageSources,
        StylistsCertifications,
        url: '',
        picture: null,
        showFinalStatusDiagnosticsUi: false,
        diagnosticApplicationId: '',
        diagnosticLoading: false,
        diagnosticError: '',
        diagnosticResult: null
      }
    },
    methods: {
      async runFinalStatusDiagnostics() {
        if (!this.isValidDiagnosticId) return

        this.diagnosticLoading = true
        this.diagnosticError = ''
        this.diagnosticResult = null

        try {
          const response = await api.getApplicationFinalStatusDiagnostics(
            this.diagnosticApplicationId.trim()
          )
          this.diagnosticResult = response.data.data || null
        } catch (error) {
          this.diagnosticError =
            error?.response?.data?.message ||
            'Could not load diagnostics. Verify the Application ID and admin login.'
        } finally {
          this.diagnosticLoading = false
        }
      },
      async copyDiagnosticResult() {
        if (!this.diagnosticResult) return

        try {
          await navigator.clipboard.writeText(
            JSON.stringify(this.diagnosticResult, null, 2)
          )
        } catch (error) {
          // silent fallback: still keep output visible for manual copy
          console.log('copy failed', error)
        }
      }
    },
    computed: {
      isValidDiagnosticId() {
        return /^[a-f\d]{24}$/i.test(this.diagnosticApplicationId.trim())
      },
      diagnosticRows() {
        if (!this.diagnosticResult) return []

        const expectedButtons = this.diagnosticResult.expectedButtons || {}
        const diagnosticLinks = this.diagnosticResult.diagnosticLinks || {}
        const clicks = this.diagnosticResult.clicks || {}
        const statuses = this.diagnosticResult.statuses || {}
        const systems = [
          {
            key: 'lb',
            label: 'Laserbeamer',
            statusKey: 'statusLB',
            classKey: 'lbClass',
            clickKey: 'lbClicked'
          },
          {
            key: 'fs',
            label: 'FreeStyler',
            statusKey: 'statusFS',
            classKey: 'fsClass',
            clickKey: 'fsClicked'
          },
          {
            key: 'ml',
            label: 'MicroLines',
            statusKey: 'statusML',
            classKey: 'mlClass',
            clickKey: 'mlClicked'
          },
          {
            key: 'ta',
            label: 'Tapes',
            statusKey: 'statusTA',
            classKey: null,
            clickKey: 'taClicked'
          }
        ]

        return systems.map(system => {
          const expectedInfo = expectedButtons[system.key] || {}
          const links = diagnosticLinks[system.key] || []
          const shouldRender =
            typeof expectedInfo.shouldRender === 'boolean'
              ? expectedInfo.shouldRender
              : links.length > 0
          const clicked =
            typeof expectedInfo.clicked === 'boolean'
              ? expectedInfo.clicked
              : !!clicks[system.clickKey]
          const status = statuses[system.statusKey] || 'Unknown'
          const className = system.classKey ? statuses[system.classKey] || '' : ''

          return {
            label: system.label,
            status,
            className,
            shouldRender,
            clicked
          }
        })
      },
      diagnosticMissingClicks() {
        return this.diagnosticRows.filter(
          row => row.shouldRender && !row.clicked
        ).length
      },
      diagnosticHeadline() {
        if (!this.diagnosticRows.length) return ''

        const expectedCount = this.diagnosticRows.filter(
          row => row.shouldRender
        ).length
        if (expectedCount === 0) {
          return 'No action buttons are expected for this application.'
        }
        if (this.diagnosticMissingClicks === 0) {
          return `All expected buttons were clicked (${expectedCount}/${expectedCount}).`
        }
        return `${this.diagnosticMissingClicks} of ${expectedCount} expected buttons have no recorded click.`
      },
      diagnosticEnglishReport() {
        return this.diagnosticRows.map(row => {
          const classPart = row.className ? ` (${row.className})` : ''
          const renderPart = row.shouldRender
            ? 'Button should be shown.'
            : 'Button is not expected to show.'
          const clickPart = row.clicked
            ? 'Click is recorded.'
            : 'No click is recorded.'
          return `${row.label}: ${row.status}${classPart}. ${renderPart} ${clickPart}`
        })
      },
      formattedDiagnosticResult() {
        if (!this.diagnosticResult) return ''
        return JSON.stringify(this.diagnosticResult, null, 2)
      },
      consumerId() {
        return process.env.NODE_ENV === 'production'
          ? '62c95b9ab193f25d1b3cb7d0'
          : '630e0bc72b3a523a972202ef'
      },
      newInquiryConsumerId() {
        return process.env.NODE_ENV === 'production'
          ? '62c95b9ab193f25d1b3cb7d0'
          : '630e0bc72b3a523a972202ef'
      },
      salonId() {
        return process.env.NODE_ENV === 'production'
          ? '6291390ac28bf31afe504bd0'
          : '6299fba54c80e66217bd730a'
      },
      newInquirySalonId() {
        return process.env.NODE_ENV === 'production'
          ? '6291390ac28bf31afe504bd0'
          : '6299fba54c80e66217bd730a'
      },
      emptyConsumerId() {
        return process.env.NODE_ENV === 'production'
          ? '62c95bf3b193f25d1b3cb7e4'
          : '630e0b9d2b3a523a972202e8'
      },
      stylistId() {
        return process.env.NODE_ENV === 'production'
          ? '6291390ac28bf31afe504bd0'
          : '653000e823ec1ff46ec608a7'
      },
      stylistAccountId() {
        return process.env.NODE_ENV === 'production'
          ? '675c9914174ff71c1c3b280c'
          : '675c9914174ff71c1c3b280c'
      },
      applicationId() {
        return process.env.NODE_ENV === 'production'
          ? '675c9916174ff71c1c3b2811'
          : '675c9916174ff71c1c3b2811'
      }
    }
  }
</script>

<style scoped>
  .diagnostic-output {
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 320px;
    overflow: auto;
    padding: 8px;
    margin-top: 8px;
    background: #f5f7fa;
    border: 1px solid #e3e5ea;
    font-size: 12px;
    font-family: monospace;
    border-radius: 4px;
  }

  .diagnostic-report-line {
    margin-top: 4px;
  }
</style>
